<script lang="ts" setup>
import AppModal from "@/components/AppModal.vue";
import type { Profile } from "~/common/types/types";
import ImportProfileFromUrlForm from "./ImportProfileFromUrlForm.vue";

const emit = defineEmits(["close", "submitted"]);

function submitted(profile: Profile) {
  emit("submitted", profile);
  closed();
}

function closed() {
    emit("close");
}

</script>
<template>
  <AppModal @close="closed">
    <template #title> Import URL </template>
    <template #body>
      <ImportProfileFromUrlForm @submitted='submitted' />
    </template>
  </AppModal>
</template>